import { useDataSourceTable } from './use_data_source_table'

export const useAdsbDataSourceTable = (controller, options) => {
  const config = {
    prefix: 'adsb',
    columns: [
      { key: 'name', label: 'ICAO' },
      { key: 'altitude', label: 'Altitude (m)', precision: 0 },
      { key: 'horVelocity', label: 'H.Vel (m/s)', precision: 0 },
      { key: 'verVelocity', label: 'V.Vel (m/s)', precision: 0 }
    ]
  }

  const table = useDataSourceTable(controller, options, config)

  Object.assign(controller, {
    setAdsbTableSeparationTarget (entity) {
      table.setSeparationTarget(entity)
    }
  })
}
